// extracted by mini-css-extract-plugin
module.exports = {"interval":"interval___3NKV7"};